<template>
  <div id="app">
      <router-view style="top: 10px; position: relative;"/>      

      <div style="margin-top: 50px;">
        <span style="font-size: 10px;" v-html="'copyrights © '+new Date().getFullYear()+' Don Quijote Recepciones | all rights reserved'">
            
          </span>
      </div>  
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  computed: {
    
  }
}


</script>


<style>
body {
  font-size: 13px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: #383838;
  -moz-osx-font-smoothing: #383838;
  text-align: center;
  color: #383838;  
}

#app {
  width: 100wh;  
}

.rowFontSize {
  font-size: 13px;
}

</style>


// WEBPACK FOOTER //
// src/App.vue